import { create } from 'zustand';

export type LeadFeedbackFilter = 'all' | 'good' | 'bad';

type FilterStore = {
    locations: number[];
    keywords: string[];
    bundles: string[];
    privateChats: number[];
    date: string[];
    dateFrom?: string;
    dateTo?: string;
    cities: string[];
    projects: number[];
    streams: number[];
    leadFeedback: LeadFeedbackFilter;
    setDate: (date: string[]) => void;
    setDateRange: (dateFrom?: string, dateTo?: string) => void;
    setBundles: (bundles: string[]) => void;
    setLocations: (locations: number[]) => void;
    setKeywords: (keywords: string[]) => void;
    setPrivateChats: (chats: number[]) => void;
    setCities: (cities: string[]) => void;
    setProjects: (projects: number[]) => void;
    setStreams: (streams: number[]) => void;
    setLeadFeedback: (leadFeedback: LeadFeedbackFilter) => void;
    clearFilter: () => void;
};

const useFilterStore = create<FilterStore>((set, _get) => ({
    bundles: [],
    setBundles: (bundles) => set({ bundles }),
    locations: [],
    setLocations: (locations) => set({ locations }),

    keywords: [],
    setKeywords: (keywords) => set({ keywords }),

    privateChats: [],
    setPrivateChats: (value) => {
        set({ privateChats: value });
    },

    date: [],
    setDate: (date) => set({ date }),
    dateFrom: undefined,
    dateTo: undefined,
    setDateRange: (dateFrom, dateTo) => set({ dateFrom, dateTo }),

    cities: [],
    setCities: (cities) => set({ cities }),

    projects: [],
    setProjects: (projects) => set({ projects }),

    streams: [],
    setStreams: (streams) => set({ streams }),

    leadFeedback: 'all',
    setLeadFeedback: (leadFeedback) => set({ leadFeedback }),

    clearFilter: () => {
        set({
            locations: [],
            keywords: [],
            privateChats: [],
            bundles: [],
            date: [],
            dateFrom: undefined,
            dateTo: undefined,
            cities: [],
            projects: [],
            streams: [],
            leadFeedback: 'all',
        });
    },
}));

export default useFilterStore;
